import { Injectable } from "@angular/core";
import { MyBudgetModel } from "app/model/myBudget/my-budget-model";
import { Observable } from "rxjs";
import { ActHttpService } from "../act-http/act-http.service";
import { environment } from "environments/environment";

@Injectable()
export class BudgetService {

  constructor(
    private actHttp: ActHttpService,
  ) { }

  getMyBudget(companyId: number, userId: number, year: number): Observable<MyBudgetModel> {
    const options = this.actHttp.getRequestOptions();
    const url = environment.endpoint.getMyBudget
      .replace('{companyId}', companyId.toString())
      .replace('{userId}', userId.toString())
      + `?year=${year}`;

    return this.actHttp.get(url, options).map( res => res.json().data);
  }
}


// WEBPACK FOOTER //
// ./src/app/services/budget/budget.service.ts